var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"icon":"delete","type":"link","size":"small"},on:{"click":e => _vm.$emit('click', e)}},[_vm._v(" 删除 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }